<template>
  <div id="batch_list__view">
    <!-- batch filters -->
    <div id="batch_list__page">
      <vx-card class="mb-10">
        <!-- Select Box -->
        <div class="vx-row grid grid-cols-6 gap-5">
          <div class="vx-col pr-0">
            <vs-input name="text" icon="icon icon-search" class="rounded-lg search-bg w-full text-black" placeholder="Search Here....." v-model="filters.search" icon-pack="feather" />
            <span class="text-danger text-sm block">{{ errors.first('step-1.Email') }}</span>
          </div>

          <!-- location filter -->
          <select-2
            id="location"
            class="w-full mb-1"
            ref="locationList"
            :value="filters.locationId"
            @input="
              (item) => {
                this.filters.locationId = item && item.value
              }
            "
            name="Location name"
            placeholder="Select Location"
            autocomplete
            label="name"
            :ssr="true"
            :params="{ order: ['location.id', 'ASC'], status: true }"
            action="location/fetchLocations"
          />

          <div class="filter_rese ml-5 mb-1">
            <vs-button class="mr-2" color="danger" type="relief" @click="clearFilter">Clear Filter</vs-button>
          </div>
        </div>
      </vx-card>
    </div>

    <!-- batch list -->
    <div class="vx-card p-6">
      <vs-table
        id="batch_list__table"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="500px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        pagination
        :max-items="this.length"
        search
        :data="batches"
      >
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">
                    {{ page * length - (length - (FilteredCount && 1)) }}
                    -
                    {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                    of {{ FilteredCount }} (filtered from {{ total }} total entries)
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="handleChangeLength(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>

          <vs-button v-if="checkPermissionByIds([permissions.BATCH_ADD])" @click="$router.push('/batches/list')" class="mt-2 mr-2" color="primary" type="relief"> Active Batch List</vs-button>
        </template>

        <template slot="thead">
          <vs-th sort-key="batch.id">Sr#</vs-th>
          <vs-th sort-key="batch.batch_name">Batch Name</vs-th>
          <vs-th>Status</vs-th>
          <vs-th sort-key="batch.description">Description</vs-th>
          <vs-th sort-key="batch.batch_number">Batch Number</vs-th>
          <vs-th>Location Name</vs-th>
          <vs-th>Plant Count </vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              {{ tr.batch_name }}
            </vs-td>
            <vs-td>
              <span v-if="!tr.statusInlineEdit">{{ tr.status }}</span>
              <select-2
                v-if="tr.statusInlineEdit"
                class="w-full"
                ref="batchStatus"
                :value="status"
                @input="(item) => (status = item && item.value)"
                name="Status"
                placeholder="Select Batch Status"
                autocomplete
                :options="BatchStatus"
                v-validate="'required'"
              />
            </vs-td>
            <vs-td>
              {{ tr.description }}
            </vs-td>
            <vs-td>
              {{ tr.batch_number }}
            </vs-td>
            <!-- location status -->
            <vs-td>
              <span v-if="!tr.locationInlineEdit">{{ tr.location && tr.location.name }}</span>
              <select-2
                v-if="tr.locationInlineEdit"
                class="w-full"
                ref="locationList"
                :value="locationId"
                @input="(item) => (locationId = item && item.value)"
                name="Location"
                placeholder="Select Location"
                autocomplete
                label="name"
                :ssr="true"
                :params="{ dropdownLocationId: locationId }"
                action="location/fetchLocations"
                v-validate="'required'"
              />
            </vs-td>
            <vs-td>{{ tr.plantCount }}</vs-td>

            <vs-td>
              <!-- location - actions - save and cancel -->
              <div class="inline-flex" v-if="checkPermissionByIds([permissions.BATCH_EDIT]) && tr.locationInlineEdit" :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                <vx-tooltip v-if="checkPermissionByIds([permissions.BATCH_EDIT])" text="Location Save">
                  <vs-button color="success" type="filled" icon="check" @click="updateLocation(i, tr.id)" />
                </vx-tooltip>
                <vx-tooltip v-if="checkPermissionByIds([permissions.BATCH_EDIT])" text="Cancel">
                  <vs-button class="ml-2" color="danger" type="filled" icon="cancel" @click="closeLocationEdit(i)" />
                </vx-tooltip>
              </div>

              <!-- status - actions - save and cancel -->
              <div class="inline-flex" v-if="checkPermissionByIds([permissions.BATCH_EDIT]) && tr.statusInlineEdit" :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                <vx-tooltip v-if="checkPermissionByIds([permissions.BATCH_EDIT])" text="Batch Status Save">
                  <vs-button color="success" type="filled" icon="check" @click="updateBatchStatus(i, tr.id)" />
                </vx-tooltip>
                <vx-tooltip v-if="checkPermissionByIds([permissions.BATCH_EDIT])" text="Cancel">
                  <vs-button class="ml-2" color="danger" type="filled" icon="cancel" @click="closeStatusEdit(i)" />
                </vx-tooltip>
              </div>

              <vs-dropdown vs-trigger-click class="cursor-pointer" v-if="!tr.locationInlineEdit && !tr.statusInlineEdit">
                <div class="p-4 border border-solid d-theme-border-grey-light cursor-pointer flex items-center justify-between font-medium">
                  Actions
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu class="invoice__actions">
                  <!-- location edit -->
                  <vs-dropdown-item @click="changeToLocationEdit(i, tr)" v-if="checkPermissionByIds([permissions.BATCH_EDIT])"> Change Location </vs-dropdown-item>

                  <!-- batch status edit -->
                  <vs-dropdown-item @click="changeToBatchEdit(i, tr)" v-if="checkPermissionByIds([permissions.BATCH_EDIT])"> Change Batch Status </vs-dropdown-item>

                  <!-- view plants -->
                  <vs-dropdown-item @click="viewBatch(tr.id)" v-if="checkPermissionByIds([permissions.BATCH_VIEW_DETAIL])"> View Batch </vs-dropdown-item>

                  <!-- edit batch -->
                  <vs-dropdown-item @click="sendToEditPage(tr.id)" v-if="checkPermissionByIds([permissions.BATCH_EDIT])"> Edit Batch Details </vs-dropdown-item>

                  <!-- delete batch -->
                  <vs-dropdown-item @click="deleteRecord(tr.id)" v-if="checkPermissionByIds([permissions.BATCH_DELETE])"> Delete Batch </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import BatchDestroyPlants from './components/modals/batch/BatchDestroyPlants'
import DestroyBatchPlants from '@/views/batches/components/modals/plants/DestroyBatchPlants'
import { batchStatus } from '@/utils/enums'

export default {
  name: 'BatchList',

  components: {
    Select2,
    BatchDestroyPlants,
    DestroyBatchPlants
  },

  data: () => ({
    processing: false,
    order: [],
    length: 10,
    page: 1,
    search: '',
    locationId: null,
    status: null,
    BatchStatus: batchStatus,
    filters: {
      search: null,
      id: null,
      locationId: null
    },
    batchFilters: {
      page: 1,
      length: 10,
      order: [],
      search: null
    },
    batchStatus: [
      { label: 'active', value: 'active' },
      { label: 'on hold', value: 'on_hold' },
      { label: 'inactive', value: 'inactive' }
    ],
    batches: [],

    //pop up var
    batchId: null,
    selectedBatch: null,
    batch_growth_phase_change_popup: false,
    isDestroyPopup: false,
    isCreateBatchPackageShow: false,
    isAddPlantModalShow: false,
    addPlantModelMounted: false,
    isAddLocationModalShow: false,
    createHarvestModelMounted: false,
    isActiveCreateHarvestModal: false,

    // assign plant tag modal
    isAssignPlantTagModalMounted: false,
    isAssignPlantTagModal: false,

    // change plant growth phase
    isChangePlantGrowthPhaseModalMounted: false,
    isChangePlantGrowthPhaseModalShow: false,

    // destroy batch plants
    isDestroyBatchPlantsModalMounted: false,
    isDestroyBatchPlantsModalShow: false,

    // report waste modal
    isReportWasteModalMounted: false,
    isReportWasteModalShow: false,

    //change plant tag
    isChangePlantTagModalMounted: false,
    isChangePlantTagModalShow: false
  }),

  mounted() {
    this.getData()
  },

  computed: {
    ...mapState('batch', ['total', 'FilteredCount']),
    ...mapState('permission', ['permissions']),
    ...mapState('auth', ['parentUser']),
    ...mapGetters('auth', ['checkPermissionByIds'])
  },

  methods: {
    ...mapMutations('batch', ['SET_STATE']),
    ...mapActions('batch', { updateBatchSpecificField: 'updateBatchSpecificField' }),

    // clear filter
    clearFilter() {
      this.filters = {
        id: null,
        locationId: null,
        search: null
      }
    },

    // change batch status
    changeToBatchEdit(i, batch) {
      this.status = batch.status
      this.batches[i].statusInlineEdit = true
      // this.SET_STATE({
      //   action: `batches[${i}].statusInLineEdit`,
      //   data: !batch.statusInLineEdit
      // })
    },

    // edit batch
    sendToEditPage(id) {
      this.$router.push(`/batches/${id}/edit`)
    },

    // view batch
    viewBatch(id) {
      this.$router.push({ name: 'view-batch', params: { id } })
    },

    // change location
    changeToLocationEdit(i, batch) {
      this.locationId = batch.locationId
      this.batches[i].locationInlineEdit = true

      // this.SET_STATE({
      //   action: `batches[${i}].locationInlineEdit`,
      //   data: !batch.locationInlineEdit
      // })
    },

    // close location edit
    closeLocationEdit(i) {
      this.locationId = null
      this.batches[i].locationInlineEdit = false
    },

    // close status edit
    closeStatusEdit(i) {
      this.status = null
      this.batches[i].statusInlineEdit = false
    },

    // update location
    updateLocation(i, id) {
      this.processing = true
      this.$store
        .dispatch('batch/updateBatchLocation', { id, locationId: this.locationId })
        .then(({ message }) => {
          this.processing = false

          this.closeLocationEdit(i)

          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.getData()
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
        .finally(() => {
          this.processing = false
        })
    },

    // update batch location
    async updateBatchStatus(i, id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure?',
        text: `${
          this.status === 'inactive'
            ? 'Changing  the batch status to "inactive" will move the batch to the Inactive Batch List'
            : 'Changing the batch status to "active" will move the batch to the Active Batches.'
        }
        Are you sure you want to save this record?`,
        acceptText: 'Yes, I am sure!',
        cancelText: 'No, cancel it!',
        accept: async () => {
          this.processing = true
          await this.$store
            .dispatch('batch/updateStatus', {
              id,
              payload: {
                batch_status: this.status,
                status_type: 'status'
              }
            })
            .then(({ message }) => {
              this.closeStatusEdit(i)

              this.$vs.notify({
                title: 'Success',
                text: message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })

              this.getData()
            })
            .catch(({ message }) => {
              this.$vs.notify({
                title: 'Error',
                text: message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
            .finally(() => {
              this.processing = false
            })
        },
        cancel: () => {
          return false
        }
      })
    },

    // update batch status
    async updateStatus(id, status, fieldStatus) {
      await this.$store
        .dispatch('batch/updateStatus', {
          id,
          payload: {
            status,
            status_type: fieldStatus
          }
        })
        .then(({ message }) => {
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.getData()
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // delete batch
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteBatch(id),
        acceptText: 'Delete'
      })
    },

    deleteBatch(id) {
      this.$store
        .dispatch('batch/delete', id)
        .then(() => {
          if (this.batches.length === 1 && this.page !== 1) {
            this.page -= 1
          }
          this.$vs.notify({
            title: 'Success',
            text: 'Batch deleted successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    getData() {
      const { page, length, order, search, filters } = this
      this.processing = true
      this.$store
        .dispatch('batch/getBatches', {
          page,
          limit: length,
          order,
          status: 'inactive',
          search,
          filters
        })
        .then(({ data }) => {
          this.batches = data.map((x) => {
            return {
              ...x,
              locationInlineEdit: false,
              statusInlineEdit: false
            }
          })
          this.processing = false
        })
        .catch(({ message }) => {
          this.processing = false

          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // add plant tag
    addPlant(tr) {
      this.batchId = tr.id
      this.addPlantModelMounted = true
      this.isAddPlantModalShow = true
    }
  },

  watch: {
    processing() {
      if (this.processing) {
        this.$vs.loading({
          container: '#batch_list__table',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#batch_list__table > .con-vs-loading')
      }
    },

    isActiveCreateHarvestModal: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.createHarvestModelMounted = false
          }, 0)
        }
      }
    },

    isAddPlantModalShow() {
      if (this.isAddPlantModalShow === false) {
        this.$nextTick(() => {
          this.addPlantModelMounted = false
        })
      }
    },

    isAssignPlantTagModal: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isAssignPlantTagModalMounted = false
          }, 0)
        }
      }
    },

    // handle callback for change plant tag
    changePlantTagModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isChangePlantTagModalMounted = false
            this.batchPlant = null
          }, 0)
        }
      }
    },

    filters: {
      deep: true,
      immediate: true,
      handler() {
        this.getData()
      }
    },

    // change growth phase
    isChangePlantGrowthPhaseModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isChangePlantGrowthPhaseModalMounted = false
          }, 0)
        }
      }
    },

    // handle callback destroy plants
    isDestroyBatchPlantsModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isDestroyBatchPlantsModalMounted = false
          }, 0)
        }
      }
    },

    // handle callback report waste modal
    isReportWasteModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isReportWasteModalMounted = false
          }, 0)
        }
      }
    },

    isChangePlantTagModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isChangePlantTagModalMounted = false
          }, 0)
        }
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.batch_growth_phase_change_popup = false
    this.isDestroyPopup = false
    this.isCreateBatchPackageShow = false
    this.isAssignPlantTagModal = false
    this.isAddPlantModalShow = false
    this.isAddLocationModalShow = false
    this.isActiveCreateHarvestModal = false
    this.isChangePlantGrowthPhaseModalShow = false
    this.isDestroyBatchPlantsModalShow = false
    this.isReportWasteModalShow = false
    this.isChangePlantTagModalShow = false

    next()
  }
}
</script>

<style lang="scss" scoped>
.invoice__actions {
  width: 250px;
  li {
    padding: 5px;
    a {
      display: flex !important;
      font-weight: bold;
      align-items: center;
    }
  }
}
</style>

<style>
.vs-dropdown--item:hover .vs-dropdown--item-link {
  font-weight: 700;
}
</style>
